<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 대상년도 -->
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="0M"
            label="평가일"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="OBLI_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="obliTypeCd"
            label="평가구분"
            v-model="searchParam.obliTypeCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!--ESF 목표 및 추진계획/실적-->
    <c-table
      ref="table"
      title="안전보건관리책임자/관리감독자 의무사항 이행평가 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--등록-->
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="openPop" />
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'safety-healthy-target',
  data() {
    return {
      searchParam: {
        period: [],
        obliTypeCd: null,
      },
      grid: {
        columns: [
          {
            name: 'obliTypeName',
            field: 'obliTypeName',
            label: '평가구분',
            align: 'center',
            sortable: true,
            style: 'width:160px',
          },
          {
            name: 'evalDt',
            field: 'evalDt',
            label: '평가일',
            align: 'center',
            sortable: true,
            style: 'width:120px',
          },
          {
            name: 'evalTargetUserDeptName',
            field: 'evalTargetUserDeptName',
            label: '평가대상자',
            align: 'left',
            sortable: true,
            style: 'width:200px',
            type: 'link'
          },
          {
            name: 'evalManagerUserName',
            field: 'evalManagerUserName',
            label: '평가자 담당',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'evalLeaderUserName',
            field: 'evalLeaderUserName',
            label: '평가자 팀장',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'evalPoint',
            field: 'evalPoint',
            label: '평가점수',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'evalGradeName',
            field: 'evalGradeName',
            label: '평가등급',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.obli.result.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.openPop(row);
    },
    openPop(row) {
      this.popupOptions.title = '안전보건관리책임자/관리감독자 의무사항 이행평가';  //ESF 목표 및 추진계획/실적 상세
      this.popupOptions.param = {
        saiSafetyHealthObliResultId: row ? row.saiSafetyHealthObliResultId : '',
      };
      this.popupOptions.target = () => import(`${'./safetyHealthObliDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
